<lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

@if (usersVM().isLoading && usersVM().items.length === 0) {
  <lib-skeleton-item-two-columns></lib-skeleton-item-two-columns>
  <lib-spinner-loading></lib-spinner-loading>
} @else if (usersVM().error && usersVM().items.length === 0) {
  <div class="ion-text-center ion-padding">
    <p class="fs-sm">{{ 'users.load_error' | translate }}</p>
    <ion-button
      size="small"
      (click)="onRetry()"
    >
      {{ 'general.retry' | translate }}
    </ion-button>
  </div>
} @else {
  <lib-infinite-scroll-header [infiniteScrollConfig]="headerConfig()"></lib-infinite-scroll-header>

  <ion-list class="ion-padding-top-0">
    @for (user of usersVM().items; track user.id) {
      <lib-user-item [user]="user"></lib-user-item>
    } @empty {
      <lib-empty-result text="users.no_users"></lib-empty-result>
    }
  </ion-list>

  @if (!usersVM().hasMore && usersVM().items.length > 0 && !usersVM().error) {
    <p class="fs-sm ion-text-center ion-padding">
      <strong>{{ 'general.no_more_data' | translate }}</strong>
    </p>
  }

  @if (usersVM().isLoadingMore) {
    <lib-skeleton-item-two-columns></lib-skeleton-item-two-columns>
    <p class="fs-xs ion-text-center ion-padding">{{ 'general.loading_data' | translate }}</p>
  }

  @if (usersVM().hasMore) {
    <ion-infinite-scroll
      position="bottom"
      threshold="136px"
      [disabled]="usersVM().isLoading || usersVM().isLoadingMore || usersVM().isStale || !!usersVM().error"
      (ionInfinite)="onIonInfinite($event)"
      class="ion-margin-negative"
    >
      <ion-infinite-scroll-content [loadingText]="'general.loading_data' | translate"></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  }
}
